import { axiosClient } from '@/helpers/auth';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useGlobalStore } from "@/store/storeGlobal.js";

const debugPrefix = '[UserPreferences]';

export const useUserPreferencesStore = defineStore('userPreferencesStore', () => {

  const userPreferences = ref();
  const globalStore = useGlobalStore();


  // try to fix timing issues with multiple api requests beeing sent upon initial page rendring
  // consider implementing something like this request manager: https://github.com/jaseeey/request-manager

  // https://jasey.blog/preventing-duplicate-api-requests-across-multiple-vue-components

  let getUserPreferencesRequest = null;

  const getUserPreferences = async () => {
    if (getUserPreferencesRequest) {
      return getUserPreferencesRequest;
    }
    getUserPreferencesRequest = (async () => {
      try {
        const response = await axiosClient.get("user-preferences")
        if (response) {
          userPreferences.value = response.data
          setDefaultNumberFormat();
          globalStore.debug(`${debugPrefix} Fetched user preferences`, userPreferences.value);
        }
      } finally {
        getUserPreferencesRequest = null;
      }
    })();
    return getUserPreferencesRequest;
  };

  function setDefaultNumberFormat () {
    if (!userPreferences.value.numberFormatThousandsSeparator)
      userPreferences.value.numberFormatThousandsSeparator = ' ';
    if (!userPreferences.value.numberFormatDecimalSeparator)
      userPreferences.value.numberFormatDecimalSeparator = ',';
  }

  async function saveFavorites (favorites) {
    await saveUserPreferences({
      dashboardComponents: userPreferences.value.dashboardComponents || [],
      homePageDatabaseObjectId: userPreferences.value.homePageDatabaseObjectId,
      homePageType: userPreferences.value.homePageType || 'dashboard',
      favorites: favorites,
      numberFormatThousandsSeparator: userPreferences.value.numberFormatThousandsSeparator || ' ',
      numberFormatDecimalSeparator: userPreferences.value.numberFormatDecimalSeparator || ',',
      dateTimeFormat: userPreferences.value.dateTimeFormat || 'DMY'
    });
  }

  async function saveUserPreferences (preferences) {
    // Backend expects UserPreferences object directly, not wrapped with userId
    globalStore.debug(`${debugPrefix} saveUserPreferences params: `, preferences);
    console.log('🔍 DEBUG: Sending to API:', preferences);

    try {
      const response = await axiosClient.post("user-preferences", preferences)
      if (response) {
        globalStore.debug(`${debugPrefix} saved user preferences`)
        console.log('🔍 DEBUG: API response:', response);
        // Replace entire object with what was sent (backend returns empty response)
        userPreferences.value = preferences;
      }
    } catch (error) {
      console.error('🔍 DEBUG: API error:', error);
      throw error;
    }
  }


  return { userPreferences, getUserPreferences, saveUserPreferences, saveFavorites }
})
